"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  AVATAR_SIZES: true,
  Avatar: true
};
exports.default = exports.Avatar = exports.AVATAR_SIZES = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _react = _interopRequireDefault(require("react"));
var _isFunction = require("../utils/isFunction");
var _Icon = require("../Icon/Icon");
var _Avatar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Avatar.css") : void 0);
var _Avatar2 = require("./Avatar.types");
Object.keys(_Avatar2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Avatar2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Avatar2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-avatar';
const AVATAR_SIZES = exports.AVATAR_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
/** An **Avatar** is a visual representation of an user in the digital space.
 * Usually, an avatar displays the user in one of the following ways:
 * photo of the user, initials of the user, placeholder icon instead of the user’s
 * personal data (photo or initials). */
const Avatar = exports.Avatar = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      ariaLabel,
      accentColor = 6,
      badgeIconName,
      border,
      className,
      iconName,
      imageUrl,
      children,
      onClick,
      size = 'sm',
      square,
      transparent,
      placeholder
    } = props,
    otherProps = __rest(props, ["ariaLabel", "accentColor", "badgeIconName", "border", "className", "iconName", "imageUrl", "children", "onClick", "size", "square", "transparent", "placeholder"]);
  const classnames = _bind.default.bind(_Avatar.default);
  const avatarClasses = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--${size}`]: !!size,
    [`${CSS_BLOCK}--accent${accentColor}`]: accentColor && !placeholder && !transparent,
    [`${CSS_BLOCK}--placeholder`]: placeholder,
    [`${CSS_BLOCK}--square`]: square,
    [`${CSS_BLOCK}--transparent`]: transparent,
    [`${CSS_BLOCK}--border`]: border,
    [`${CSS_BLOCK}--clickable`]: onClick
  }, className);
  const iconSizeMap = {
    xl: 'xl',
    lg: 'lg-plus',
    md: 'lg-minus',
    sm: 'md-minus',
    xs: 'sm'
  };
  let innerContent;
  // render a gender neutral icon if provided initial are longer than 3 characters
  if (children) {
    if ((0, _reactToString.default)(children).length > 3) {
      innerContent = /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        ariaHidden: true,
        iconName: "user",
        size: iconSizeMap[size]
      });
    } else {
      innerContent = children;
    }
  } else if (iconName) {
    innerContent = /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      ariaHidden: true,
      iconName: iconName,
      size: iconSizeMap[size]
    });
  }
  const badgeIconSizeMap = {
    xl: 'sm',
    lg: 'xs-plus',
    md: 'xs',
    sm: 'xs',
    xs: 'xs'
  };
  const content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, innerContent, onClick && badgeIconName && (/*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames(`${CSS_BLOCK}__badge`),
    iconName: badgeIconName,
    size: badgeIconSizeMap[size]
  })));
  if ((0, _isFunction.isFunction)(onClick)) {
    return /*#__PURE__*/_react.default.createElement("button", Object.assign({
      type: "button"
    }, otherProps, {
      tabIndex: 0,
      onClick: onClick,
      "aria-label": ariaLabel,
      className: avatarClasses,
      style: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.trim()) ? {
        backgroundImage: `url(${imageUrl})`
      } : undefined,
      ref: ref
    }), content);
  }
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({}, otherProps, {
    "aria-label": ariaLabel,
    className: avatarClasses,
    role: "img",
    style: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.trim()) ? {
      backgroundImage: `url(${imageUrl})`
    } : undefined,
    ref: ref
  }), content);
});
Avatar.displayName = 'Avatar';
var _default = exports.default = Avatar;